export var SharedTokensSubjects;
(function (SharedTokensSubjects) {
    SharedTokensSubjects["TokensTable"] = "shared-tokens-table";
    SharedTokensSubjects["EmptyState"] = "empty-state-shared-tokens";
    SharedTokensSubjects["Modal"] = "shared-tokens-modal";
    SharedTokensSubjects["NameField"] = "name";
    SharedTokensSubjects["TokenFiltersSelect"] = "select-token-filters";
    SharedTokensSubjects["FiltersOperator"] = "filters-operator";
    SharedTokensSubjects["SubmitButton"] = "save-shared-token";
    SharedTokensSubjects["FiltersTable"] = "token-filters-table";
    SharedTokensSubjects["FiltersTableDescriptionInput"] = "token-filter-description";
    SharedTokensSubjects["FiltersTableFilterInput"] = "token-filter-filter";
    SharedTokensSubjects["FiltersTableValueInput"] = "token-filter-value";
    SharedTokensSubjects["SearchTokenNotification"] = "search-token-notification";
    SharedTokensSubjects["CreateTokenNotification"] = "create-token-notification";
    SharedTokensSubjects["UpdateTokenNotification"] = "update-token-notification";
    SharedTokensSubjects["DeleteTokenNotification"] = "delete-token-notification";
    SharedTokensSubjects["SearchFilterNotification"] = "search-filter-notification";
    SharedTokensSubjects["CreateFilterNotification"] = "create-filter-notification";
    SharedTokensSubjects["DeleteFilterNotification"] = "delete-filter-notification";
})(SharedTokensSubjects || (SharedTokensSubjects = {}));
//# sourceMappingURL=shared-tokens.enum.js.map